import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faYoutube,
  faLinkedin,
 
} from "@fortawesome/free-brands-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

const Footer = () => {
  const [showOnline, setShowOnline] = useState(false);
  const [showOffline, setShowOffline] = useState(false);
  return (
    <footer className="footer-container">
      <div className="footer-grid">

        {/* ================= BRAND COLUMN ================= */}
        <div className="footer-brand">
          <h3 className="footer-logo">Forge Your Peak</h3>

          <p>
            Transforming athletes through advanced vision & cognitive
            training — measurement, training plans, and progress tracking.
          </p>

          {/* CTA BOX */}
          <div className="footer-cta-box">
            <h4>Ready to Level Up?</h4>
            <p>Start your 3-Day Eye Health Reset bootcamp.</p>

              <Link className="cta-primary" to="/vision-ignite-webinar">
                             Join Free webinar
               </Link>

            <Link to="/dashboard-login" className="cta-secondary">
              Member Login
            </Link>
          </div>

          {/* SOCIAL ICONS */}
          <div className="footer-social">
            <a
              href="https://instagram.com/vevekseetharaman"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>

            <a
              href="https://youtube.com/@vevekseetharaman3857?si=1oWDnyJPdFX2qPez"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a>

            <a
              href="https://www.linkedin.com/in/vevek-seetharaman"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a
              href="https://forgeyourpeak.in"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Website"
            >
              <FontAwesomeIcon icon={faGlobe} />
            </a>
          </div>
        </div>

        {/* ================= PROGRAMS ================= */}
        <div>
          <h4 className="footer-heading">PROGRAMS</h4>

          {/* Online Programs */}
          <h5
            className="program-subheading"
            onClick={() => setShowOnline(!showOnline)}
            style={{ cursor: "pointer" }}
          >
            Online Programs
          </h5>

          {showOnline && (
            <ul>
              <li>
                <a
                  href="https://learn.forgeyourpeak.in/web/checkout/698a8ef1831f481067f8b8f1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Bootcamp
                </a>
              </li>
              <li>
                <Link to="/ignite">Ignite</Link>
              </li>
            </ul>
          )}

          {/* Offline Programs */}
          <h5
            className="program-subheading"
            onClick={() => setShowOffline(!showOffline)}
            style={{ cursor: "pointer" }}
          >
            Offline Programs
          </h5>

          {showOffline && (
            <ul>
              <li>Eye Health Reset Mastery</li>
              <li>Athletic Vision Mastery</li>
              <li>Reaction Speed Mastery</li>
              <li>Hand-Eye Coordination Mastery</li>
              <li>Memory & Decision Mastery</li>
            </ul>
          )}
        </div>
        {/* ================= MEASUREMENTS ================= */}
       <div>
          <h4 className="footer-heading">MEASUREMENTS</h4>

          <ul className="measure-list">
            <li>Binocular Visual Acuity </li>
            <li>Dynamic Visual Acuity</li>
            <li>Contrast Sensitivity </li>
            <li>Color Perception </li>
            <li>Stereopsis </li>

            <li>Simple Reaction Speed</li>
            <li>Complex Reaction Speed</li>

            <li>Hand-Eye Coordination</li>
            <li>Executive Scan</li>
            <li>Digit Span</li>
            <li>Short Term Visual Memory</li>
            <li>Anticipation</li>
            <li>Player Dashboard</li>
          </ul>
        </div>

        {/* ================= COMPANY ================= */}
        <div>
          <h4 className="footer-heading">COMPANY</h4>
          <ul>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/benefits">Benefits</Link></li>
            <li><Link to="/contact-us">Contact Us</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service">Terms of Service</Link></li>
            <li><Link to="/refund-policy">Refund Policy</Link></li>
          </ul>
        </div>

      </div>

      <hr className="footer-divider" />

      <div className="footer-bottom">
        <p>© 2024 Forge Your Peak. All rights reserved.</p>

        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
          <Link to="/contact-us">Contact Us</Link>
          <Link to="/refund-policy">Refund Policy</Link>
        </div>
      </div>

      <p className="footer-disclaimer">
        Disclaimer: Results may vary. Commitment to training required for optimal performance gains.
      </p>

      {/* BACK TO TOP */}
      <button
        className="back-to-top"
        onClick={() =>
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          })
        }
      >
        ↑
      </button>
    </footer>
  );
};

export default Footer;